import { api } from 'data/api/api'

import { GetInfoBoardPostResp, GetInfoBoardPostsResp } from '../types/info-board'

export const getInfoBoardPost = (postId: number) =>
  api.get<GetInfoBoardPostResp>(`/info_posts/${postId}`)

export const getInfoBoardPosts = () => api.get<GetInfoBoardPostsResp>('/info_posts')
